import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SkipApiInterceptorToken } from '../http/api-interceptor.service';
import { Config } from './config.model';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    public constructor(private readonly httpClient: HttpClient) {}

    public getAppConfig(): Observable<Config> {
        return this.httpClient.get<Config>('assets/config.json', {
            context: new HttpContext().set(SkipApiInterceptorToken, {
                skipApiInterceptor: true,
            }),
        });
    }
}
